var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col countdown__block"},[_c('span',{staticClass:"countdown__digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.minutes))+" : "+_vm._s(_vm._f("twoDigits")(_vm.seconds)))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }